import * as yup from "yup";

const addViewValidationSchema = yup.object().shape({
  name: yup.string().required(),
});

export default addViewValidationSchema;
